import { BaseResource } from '../base-resource'

export class ItemPriceGroup extends BaseResource{
    priceTypeId: number;
    priceType: string;
    priceExcludingTax: number;
    priceIncludingTax: number;
    concessionId: number;
    concession: string;
}